import React from "react";
import { MapPin } from "lucide-react";

/**
 * Pin estilo Uber con cabeza redonda + cola triangular + anillo
 * pulsante. Respeta el color de la empresa pasado en `color`.
 *
 * Usa la animación CSS `map-pin-pulse` y `map-pin-shadow` ya
 * definidas en index.css (compartidas con MapPicker).
 */
export default function BrandPin({ color = "#0A0A0A" }) {
  return (
    <div className="pointer-events-none flex flex-col items-center -translate-y-4">
      <div className="relative" style={{ color }}>
        <span className="absolute inset-0 rounded-full map-pin-pulse" aria-hidden />
        <div
          className="relative h-10 w-10 rounded-full flex items-center justify-center text-white ring-2 ring-white"
          style={{
            backgroundColor: color,
            boxShadow:
              "0 4px 10px rgba(0,0,0,0.25), inset 0 -3px 6px rgba(0,0,0,0.2), inset 0 3px 6px rgba(255,255,255,0.25)",
          }}
        >
          <MapPin size={20} fill="white" strokeWidth={2.5} />
        </div>
        <div
          className="absolute left-1/2 -bottom-1.5 -translate-x-1/2 w-3.5 h-3.5 rotate-45 ring-2 ring-white"
          style={{
            backgroundColor: color,
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
          }}
          aria-hidden
        />
      </div>
      <div
        className="mt-2 h-1.5 w-8 rounded-full bg-black/35 blur-[2px] map-pin-shadow"
        aria-hidden
      />
    </div>
  );
}
